export default {
  chatIconAriaLabel: '{{teamName}} Chat Widget Icon',
};
